import Vue from "vue";
import Vuex from "vuex";
import jsonp from "jsonp";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        enterprise: "",
        industry: "",
        eDropdown: false,
        iDropdown: false,
        bTableData: [],
        tData: {},
        bData: [],
        tOption: null,
        lock: false,
        selectedPlatform: null,
        selectedEnterprise: null,
        // 四大片区数据展示
        zoneData: {},
        showZoon: false
    },
    mutations: {
        updatazoneData(state, data) {
            console.log(data, '-----1111');
            // if(data.name == '高端装备制造片区') {
            //     data.desc = '大力发展智能网联与新能源汽车整车及零部件制造、生物医药、都市消费等产业。'
            // }
            state.zoneData = data
        },
        updateShowZoon(state, flag) {
            state.showZoon = flag
        },
        updateEnterprise(state, enterprise) {
            state.enterprise = enterprise;
        },
        updateIndustry(state, industry) {
            state.industry = industry;
        },
        toggleEDropdown(state, flag) {
            state.eDropdown = flag;
        },
        toggleIDropdown(state, flag) {
            state.iDropdown = flag;
        },
        updateBTableData(state, tableData) {
            state.bTableData = tableData;
        },
        updateTData(state, data) {
            state.tData = data;
        },
        updateBData(state, data) {
            state.bData = data;
        },
        updateTOption(state, option) {
            state.tOption = option;
        },
        updateLock(state, flag) {
            state.lock = flag;
        },
        updateSelectedPlatform(state, platform) {
            state.selectedPlatform = platform;
        },
        updateSelectedEnterprise(state, enterprise) {
            state.selectedEnterprise = enterprise;
        }
    },
    actions: {
        updateBTableDataAsync({ commit }, val) {

            const { enterprise, industry } = val;

            const updatedEnterprise = enterprise? `${enterprise.split("(")[0]}库` : "";

            const updatedIndustry = industry? `${industry.split("(")[0]}` : "";

            const url = `https://api.21jingji.com/nansha/company?category=${updatedEnterprise}&search_industry=${updatedIndustry}`;

            jsonp(url, null, (_, res) => {

                const { data } = res;

                commit("updateBTableData", data);
            });
        },
        updateTDataAsync({ commit }) {

            const url = "https://api.21jingji.com/nansha/nodeRegion";

            jsonp(url, null, (_, res) => {

                const { data } = res;

                commit("updateTData", data);
            });
        },
        updateBDataAsync({ commit }) {

            const url = `https://api.21jingji.com/nansha/company?category=${''}&search_industry=${''}`;

            jsonp(url, null, (_, res) => {

                const { data } = res;

                commit("updateBData", data);
            });
        }
    }
});